import React from "react";

function WhatIsDeFi() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a DeFi Staking Platform?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A DeFi Staking Platform is a decentralized finance application
                  that allows users to lock up their cryptocurrency wealth to
                  secure operations, earn network rewards, and provide
                  liquidity. It represents a foundational pillar by promoting
                  token retention strategies and generating highly robust yield
                  pathways.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatIsDeFi;
